var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGithubDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 81,
    viewBox: "0 0 81 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.5 10.5C23.925 10.5 10.5 24.2646 10.5 41.2588C10.5 54.8696 19.0875 66.3657 31.0125 70.4412C32.5125 70.7104 33.075 69.7876 33.075 68.9802C33.075 68.2497 33.0375 65.8274 33.0375 63.2514C25.5 64.674 23.55 61.3674 22.95 59.6372C22.6125 58.7529 21.15 56.023 19.875 55.2925C18.825 54.7158 17.325 53.2932 19.8375 53.2547C22.2 53.2163 23.8875 55.4848 24.45 56.4075C27.15 61.0598 31.4625 59.7526 33.1875 58.9451C33.45 56.9458 34.2375 55.6001 35.1 54.8311C28.425 54.0622 21.45 51.4092 21.45 39.644C21.45 36.299 22.6125 33.5307 24.525 31.3775C24.225 30.6086 23.175 27.4558 24.825 23.2265C24.825 23.2265 27.3375 22.419 33.075 26.3792C35.475 25.6872 38.025 25.3411 40.575 25.3411C43.125 25.3411 45.675 25.6872 48.075 26.3792C53.8125 22.3806 56.325 23.2265 56.325 23.2265C57.975 27.4558 56.925 30.6086 56.625 31.3775C58.5375 33.5307 59.7 36.2605 59.7 39.644C59.7 51.4477 52.6875 54.0622 46.0125 54.8311C47.1 55.7924 48.0375 57.6379 48.0375 60.5215C48.0375 64.6355 48 67.9421 48 68.9802C48 69.7876 48.5625 70.7488 50.0625 70.4412C56.018 68.3799 61.1932 64.4555 64.8594 59.2205C68.5256 53.9855 70.4984 47.7036 70.5 41.2588C70.5 24.2646 57.075 10.5 40.5 10.5Z",
    fill: "white",
    stroke: "none"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGithubDark);
export default __webpack_public_path__ + "static/media/github-dark.93ef248e83eb5d2a4056821ad0ac2f00.svg";
export { ForwardRef as ReactComponent };